import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSectionClosed = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 9 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.50946 6.27013L1.5932 1.17394C0.932935 0.687426 0 1.15885 0 1.97899L0 13.2634C0 14.1278 1.02261 14.585 1.66679 14.0087L8.58305 7.82043C9.05592 7.39734 9.02027 6.64652 8.50946 6.27013Z",
		fill: "#717D96"
	})
});
export default SvgSectionClosed;
